// 첫 플레이 시 자동 부여되는 기본 닉네임 풀.
// BE 닉네임 최대 길이(20)를 넘지 않도록 base 는 최대 8자, suffix 4자리.

const NICKNAME_POOL: ReadonlyArray<string> = [
  '푸른블루미', '긍정블루미', '행복블루미', '햇살블루미', '화창블루미',
  '평화블루미', '따스블루미', '다정블루미', '든든블루미', '살랑블루미',
  '포근블루미', '산뜻블루미', '청량블루미', '청정블루미', '활기블루미',
  '미소블루미', '웃음블루미', '봄날블루미', '새싹블루미', '떡잎블루미',
  '초록블루미', '노을블루미', '별빛블루미', '달빛블루미', '햇빛블루미',
  '무지개블루미', '바람블루미', '구름블루미', '산들블루미', '반짝블루미',
  '차분블루미', '평온블루미', '고요블루미', '잔잔블루미', '단정블루미',
  '정성블루미', '진심블루미', '따뜻블루미', '향긋블루미', '맑은블루미',
  '깨끗블루미', '시원블루미', '솔솔블루미', '봄꽃블루미', '가을빛블루미',
  '여름빛블루미', '겨울빛블루미', '봉오리블루미', '꽃잎블루미', '잎새블루미',
  '정원블루미', '화단블루미', '새벽블루미', '아침블루미', '오후블루미',
  '저녁블루미', '별밤블루미', '달밤블루미', '아늑블루미', '보송블루미',
  '햇살가득', '봄날가득', '행복가득', '미소가득', '사랑가득',
  '응원가득', '다정가득',
  '화창한날', '빛나는날', '푸른하늘', '맑은하늘', '노을하늘',
  '별빛하늘', '달빛정원', '햇살정원', '푸른정원', '작은화분',
  '떡잎새싹', '푸른잎새', '봄날의꿈', '새벽이슬', '햇살한줌',
  '향긋한꽃', '봄바람러', '산들바람', '솔솔바람', '따뜻한봄',
  '시원한여름', '청량한가을', '포근한겨울', '행복한날', '평화한날',
  '다정한하루', '빛나는하루', '따스한오후', '푸른들판', '환한미소',
  '활짝웃음', '새로운날', '좋은하루',
];

const FALLBACK = '푸른블루미';

export function generateRandomNickname(): string {
  const base = NICKNAME_POOL[Math.floor(Math.random() * NICKNAME_POOL.length)] ?? FALLBACK;
  const suffix = Math.floor(Math.random() * 10000)
    .toString()
    .padStart(4, '0');
  return `${base}${suffix}`;
}
